import CouponVM from './coupon-vm';
export default {
  init : function() {
    console.log('Initializing Kadenze.CommonResourceCouponView');
    let validationOptions = Kadenze.Knockout.DEFAULT_VALIDATION_OPTIONS;

    let resource_id = $('#resource_id').val();
    let course_id = $('#course_id').val();
    let showDiscount = $('#show_discount').val();
    ko.applyBindingsWithValidation(new CouponVM(resource_id, course_id, showDiscount), document.getElementById('js-resource-coupon-view'), validationOptions);
  }
};
